import type { ReactNode } from 'react';

interface FlagIconProps {
  code: string;
  className?: string;
}

export function FlagIcon({ code, className = 'w-6 h-6' }: FlagIconProps) {
  type FlagCode = 'nl' | 'de' | 'en' | 'fr' | 'da' | 'it' | 'es' | 'pl' | 'pt' | 'cs';
  const flags = {
    nl: (
      <svg viewBox="0 0 900 600" className="w-full h-full" style={{ display: 'block' }} xmlns="http://www.w3.org/2000/svg">
        <defs>
          <clipPath id="circle-nl">
            <circle cx="450" cy="300" r="300"/>
          </clipPath>
        </defs>
        <g clipPath="url(#circle-nl)">
          <rect fill="#21468B" width="900" height="600"/>
          <rect fill="#FFF" width="900" height="400"/>
          <rect fill="#AE1C28" width="900" height="200"/>
        </g>
      </svg>
    ),
    de: (
      <svg viewBox="0 0 900 600" className="w-full h-full" style={{ display: 'block' }} xmlns="http://www.w3.org/2000/svg">
        <defs>
          <clipPath id="circle-de">
            <circle cx="450" cy="300" r="300"/>
          </clipPath>
        </defs>
        <g clipPath="url(#circle-de)">
          <rect fill="#000" width="900" height="600"/>
          <rect fill="#D00" y="200" width="900" height="400"/>
          <rect fill="#FFCE00" y="400" width="900" height="200"/>
        </g>
      </svg>
    ),
    en: (
      <svg viewBox="0 0 900 600" className="w-full h-full" style={{ display: 'block' }} xmlns="http://www.w3.org/2000/svg">
        <defs>
          <clipPath id="circle-en">
            <circle cx="450" cy="300" r="300"/>
          </clipPath>
        </defs>
        <g clipPath="url(#circle-en)">
          <path d="M0,0 v600 h900 v-600 z" fill="#012169"/>
          <path d="M0,0 L900,600 M900,0 L0,600" stroke="#fff" strokeWidth="90"/>
          <clipPath id="t">
            <path d="M450,300 h450 v300 z v-300 h-450 z h-450 v300 z v-300 h450 z"/>
          </clipPath>
          <path d="M0,0 L900,600 M900,0 L0,600" clipPath="url(#t)" stroke="#C8102E" strokeWidth="60"/>
          <path d="M450,0 v600 M0,300 h900" stroke="#fff" strokeWidth="150"/>
          <path d="M450,0 v600 M0,300 h900" stroke="#C8102E" strokeWidth="90"/>
        </g>
      </svg>
    ),
    fr: (
      <svg viewBox="0 0 900 600" className="w-full h-full" style={{ display: 'block' }} xmlns="http://www.w3.org/2000/svg">
        <defs>
          <clipPath id="circle-fr">
            <circle cx="450" cy="300" r="300"/>
          </clipPath>
        </defs>
        <g clipPath="url(#circle-fr)">
          <rect fill="#ED2939" width="900" height="600"/>
          <rect fill="#FFF" width="600" height="600"/>
          <rect fill="#002395" width="300" height="600"/>
        </g>
      </svg>
    ),
    da: (
      <svg viewBox="0 0 900 600" className="w-full h-full" style={{ display: 'block' }} xmlns="http://www.w3.org/2000/svg">
        <defs>
          <clipPath id="circle-da">
            <circle cx="450" cy="300" r="300"/>
          </clipPath>
        </defs>
        <g clipPath="url(#circle-da)">
          <rect fill="#C60C30" width="900" height="600"/>
          <rect fill="#FFF" x="240" width="80" height="600"/>
          <rect fill="#FFF" y="260" width="900" height="80"/>
        </g>
      </svg>
    ),
    it: (
      <svg viewBox="0 0 900 600" className="w-full h-full" style={{ display: 'block' }} xmlns="http://www.w3.org/2000/svg">
        <defs>
          <clipPath id="circle-it">
            <circle cx="450" cy="300" r="300"/>
          </clipPath>
        </defs>
        <g clipPath="url(#circle-it)">
          <rect fill="#CE2B37" width="900" height="600"/>
          <rect fill="#FFF" width="600" height="600"/>
          <rect fill="#009246" width="300" height="600"/>
        </g>
      </svg>
    ),
    es: (
      <svg viewBox="0 0 900 600" className="w-full h-full" style={{ display: 'block' }} xmlns="http://www.w3.org/2000/svg">
        <defs>
          <clipPath id="circle-es">
            <circle cx="450" cy="300" r="300"/>
          </clipPath>
        </defs>
        <g clipPath="url(#circle-es)">
          <rect fill="#AA151B" width="900" height="600"/>
          <rect fill="#F1BF00" y="150" width="900" height="300"/>
        </g>
      </svg>
    ),
    pl: (
      <svg viewBox="0 0 900 600" className="w-full h-full" style={{ display: 'block' }} xmlns="http://www.w3.org/2000/svg">
        <defs>
          <clipPath id="circle-pl">
            <circle cx="450" cy="300" r="300"/>
          </clipPath>
        </defs>
        <g clipPath="url(#circle-pl)">
          <rect fill="#DC143C" width="900" height="600"/>
          <rect fill="#FFF" width="900" height="300"/>
        </g>
      </svg>
    ),
    pt: (
      <svg viewBox="0 0 900 600" className="w-full h-full" style={{ display: 'block' }} xmlns="http://www.w3.org/2000/svg">
        <defs>
          <clipPath id="circle-pt">
            <circle cx="450" cy="300" r="300"/>
          </clipPath>
        </defs>
        <g clipPath="url(#circle-pt)">
          <rect fill="#FF0000" width="900" height="600"/>
          <rect fill="#006600" width="360" height="600"/>
          <circle cx="360" cy="300" r="72" fill="#FFCC00"/>
        </g>
      </svg>
    ),
    cs: (
      <svg viewBox="0 0 900 600" className="w-full h-full" style={{ display: 'block' }} xmlns="http://www.w3.org/2000/svg">
        <defs>
          <clipPath id="circle-cs">
            <circle cx="450" cy="300" r="300"/>
          </clipPath>
        </defs>
        <g clipPath="url(#circle-cs)">
          <rect fill="#D7141A" width="900" height="600"/>
          <rect fill="#FFF" width="900" height="300"/>
          <path d="M0 0 L450 300 L0 600 Z" fill="#11457E"/>
        </g>
      </svg>
    ),
  } satisfies Record<FlagCode, ReactNode>;

  const flagCode = code in flags ? (code as FlagCode) : 'en';

  return (
    <div className={`rounded-full overflow-hidden inline-flex items-center justify-center ${className}`} style={{ aspectRatio: '1/1' }}>
      {flags[flagCode]}
    </div>
  );
}
